import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=485e9c1d&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485e9c1d')) {
      api.createRecord('485e9c1d', component.options)
    } else {
      api.reload('485e9c1d', component.options)
    }
    module.hot.accept("./Donation.vue?vue&type=template&id=485e9c1d&", function () {
      api.rerender('485e9c1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Donation.vue"
export default component.exports